export default __webpack_public_path__ + "2931994a26f7d46dab664da9ad57c350.ttf";